import { Link } from 'react-router-dom';
import type { Movie } from '@/types/media';
import { formatViews } from '@/utils/media';

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

export default function MovieCard({ movie, showSummary = false }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-800 bg-background-900 transition-colors hover:border-primary-600"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-800">
        <img
          src={movie.cover}
          alt={`${movie.title}封面`}
          title={`${movie.title} 最新${movie.category === 'movie' ? '电影' : '电视剧'}在线观看`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/85 to-transparent" />
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-950">
          <i className="ri-star-fill text-[11px]" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute left-2 top-2 rounded-md bg-black/60 px-2 py-0.5 text-xs font-medium text-foreground-100 backdrop-blur">
          {movie.category === 'movie' ? '电影' : '电视剧'}
        </span>
        <span className="absolute inset-x-0 bottom-0 truncate px-2.5 pb-1.5 text-xs font-medium text-primary-300">
          {movie.updateStatus}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500/90 text-background-950">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-50 transition-colors group-hover:text-primary-400">
          {movie.title}
        </h3>
        <p className="mt-1.5 truncate text-xs text-foreground-400">
          {movie.year} · {movie.region} · {movie.genre.slice(0, 2).join(' / ')}
        </p>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-500">
            {movie.summary}
          </p>
        )}
        <div className="mt-2.5 flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-accent-500" />
            {formatViews(movie.views)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {movie.updatedAt}
          </span>
        </div>
      </div>
    </Link>
  );
}